import Phaser from 'phaser';


export default class SetsumeiBtn{

    constructor(container){
        this.scene =  GAME_REF.scene;
        this.emitter = new Phaser.Events.EventEmitter();
        this.container = container;
        this.btn = null;
        this.isActive = false;
        this._init();
    }


    render(){
        this.isActive = true;

        this.btn.alpha = 0;
        this.btn.setScale(1.1);

        this.scene.tweens.add({
            targets: this.btn,
            alpha: 1,
            scaleX: 1,
            scaleY: 1,
            duration: 500,
            delay: 500,
            ease: 'Cubic.easeOut',
            onStart:()=>{
                this.btn.alpha = 0;
                this.btn.visible = true;
            }
        });
    }
    

    hide(){
        this.scene.tweens.killTweensOf(this.btn);
        this.btn.visible = false;
        this.btn.alpha = 0;
    }


    _init(){
        this.EVENT_CLICK = 'setsumei_click';
        this._create();
    }


    _create(){
        this.btn = this.scene.add.sprite(945, 155, 'btn_setsumei');
        this.container.add(this.btn);
        this.btn.setOrigin(0.5, 0.5);
        this.btn.setInteractive();
        this.btn.visible = false;

        this.btn.on('pointerover', ()=>{
            if(!this.isActive) return;
            this.scene.input.setDefaultCursor('pointer');
        });
        this.btn.on('pointerout', ()=>{
            this.scene.input.setDefaultCursor('default');
        });
        this.btn.on('pointerdown', ()=>{
            if(!this.isActive) return;
            this.hide();
            this.emitter.emit(this.EVENT_CLICK);
        });
    }
}